export default {
  noPoverty: 'Fin de la pobreza',
  zeroHunger: 'Hambre cero',
  goodHealthAndWellBeing: 'Salud y bienestar',
  qualityEducation: 'Educación de calidad',
  genderEquality: 'Igualdad de género',
  cleanWaterAndSanitation: 'Agua limpia y saneamiento',
  affordableAndCleanEnergy: 'Energía asequible y no contaminante',
  decentWorkAndEconomicGrowth: 'Trabajo decente y crecimiento económico',
  industryInnovationAndInfrastructure: 'Industria, innovación e infraestructura',
  reducedInequality: 'Reducción de las desigualdades',
  sustainableCitiesAndCommunities: 'Ciudades y comunidades sostenibles',
  responsibleConsumptionAndProduction: 'Producción y consumo responsables',
  climateAction: 'Acción por el clima',
  lifeBelowWater: 'Vida submarina',
  lifeOnLand: 'Vida de ecosistemas terrestres',
  peaceJusticeAndStrongInstitutions: 'Paz, justicia e instituciones sólidas',
  partnershipForTheGoals: 'Alianzas para lograr los objetivos',
  seeCollection: 'Ver todos'
}

export const en = {
  noPoverty: 'No poverty',
  zeroHunger: 'Zero hunger',
  goodHealthAndWellBeing: 'Good health and well-being',
  qualityEducation: 'Quality education',
  genderEquality: 'Gender equality',
  cleanWaterAndSanitation: 'Clean water and sanitation',
  affordableAndCleanEnergy: 'Affordable and clean energy',
  decentWorkAndEconomicGrowth: 'Decent work and economic growth',
  industryInnovationAndInfrastructure: 'Industry, Innovation and Infrastructure',
  reducedInequality: 'Reduced inequality',
  sustainableCitiesAndCommunities: 'Sustainable cities and communities',
  responsibleConsumptionAndProduction: 'Responsible consumption and production',
  climateAction: 'Climate action',
  lifeBelowWater: 'Life below water',
  lifeOnLand: 'Life on land',
  peaceJusticeAndStrongInstitutions: 'Peace, justice and strong institutions',
  partnershipForTheGoals: 'Partnership for the goals',
  seeCollection: 'See all'
}

export const ca = {
  noPoverty: 'Fi de la pobresa',
  zeroHunger: 'Fam zero',
  goodHealthAndWellBeing: 'Salut i benestar',
  qualityEducation: 'Educació de qualitat',
  genderEquality: 'Igualtat de génere',
  cleanWaterAndSanitation: 'Aigua neta y sanejament',
  affordableAndCleanEnergy: 'Energia neta i assequible',
  decentWorkAndEconomicGrowth: 'Treball digne i crexement econòmic',
  industryInnovationAndInfrastructure: 'Indústria innovació infraestructures',
  reducedInequality: 'Reducció de les desigualtats',
  sustainableCitiesAndCommunities: 'Ciutats y comunitats sostenibles',
  responsibleConsumptionAndProduction: 'Consum y producció responsables',
  climateAction: 'Acció climàtica',
  lifeBelowWater: 'Vida submarina',
  lifeOnLand: 'Vida terrestre',
  peaceJusticeAndStrongInstitutions: 'Pau, justícia i institucions sòlides',
  partnershipForTheGoals: 'Aliança pels objectius',
  seeCollection: 'Veure tots'
}
